export enum DeliveryPlatformKind {
  ChromeLike = 5,
  Safari = 7,
  Firefox = 8
}
